// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-system-notifications-onboardings .fi-onboarding-progress-bar {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./Source/app/system-notifications/onboardings/fi-system-notifications-onboardings.component.scss"],"names":[],"mappings":"AACE;EACE,WAAA;AAAJ","sourcesContent":[".fi-system-notifications-onboardings {\r\n  .fi-onboarding-progress-bar {\r\n    width: 100%;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
